import { Component, OnInit } from '@angular/core';
import { ContextChange } from '@sdbn/appclient';
import { AbstractWidgetComponent } from '@sdbn/appclient';
import { InstructionPage } from '@sdbn/appclient';
import { HttpService } from '@sdbn/appclient';

@Component({
  selector: 'app-text-widget',
  templateUrl: './text-widget.component.html',
  styleUrls: ['./text-widget.component.scss']
})
export class TextWidgetComponent extends AbstractWidgetComponent implements OnInit {

  page = new InstructionPage({});

  constructor(private httpService: HttpService) {

    super();

  }

  ngOnInit(): void {
  }

  onContextChange(contextChange: ContextChange) {
  }

  onSetElementAndContext() {
    const contentFile = this.dashboardContext.getContextValue('dashboardConfiguration').contentFile;
    this.httpService.get(contentFile)
        .subscribe(
          pageContent => {
            this.page = new InstructionPage(pageContent);
          }, error => {
            console.error('Failed to load ' + contentFile, error);
          }
        );
  }

}
